import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import FilesTable from './components/FilesTable';
import { useRole } from './hooks/useRole';
import AdminPanel from './components/AdminPanel';



function App() {
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();
  const { isAdmin } = useRole();

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="App">
      {!isAuthenticated ? (
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <h2>Welcome to the Classic Mod Portal</h2>
          <p>Log in to access your mods</p>
          <button onClick={() => loginWithRedirect()}>⚽ Log In</button>
        </div>
      ) : (
        <>
          <button
            className="logout-button"
            onClick={() => logout({ returnTo: window.location.origin })}
          >
            Log Out
          </button>

          {!isAdmin && <FilesTable />}
          {isAdmin && <AdminPanel />}
        </>
      )}
    </div>

  );
}

export default App;